<template>
  <div class="start">
  </div>
</template>

<script>

    export default {
        name: 'Start',
        components: {

        },
        created() {
            this.$router.push('/')
            this.$store.commit('CLOSE_POPUP')
        },      
        updated() {
            this.$router.push('/')
            this.$store.commit('CLOSE_POPUP')
        },      
    }
</script>

<style lang="scss" scoped>

</style>